import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { DistributorInfoEditMode } from './components/distributorInfoEditMode/DistributorInfoEditMode'
import { DistributorInfoReadMode } from './components/distributorInfoReadMode/DistributorInfoReadMode'
import { TRANSLATION_KEYS } from './translations'

interface IDistributorInfoProps {
  totalSales: Nullable<number>
  hpDedicatedSales: Nullable<number>
  employersCount: Nullable<number>
}

export const DistributorInfo: FC<IDistributorInfoProps> = ({
  totalSales,
  hpDedicatedSales,
  employersCount,
}) => {
  const isEditMode = useSelector(selectPublishingMode)
  return (
    <div>
      <FieldLabel labelTranslation={TRANSLATION_KEYS.fieldLabel} />
      {!isEditMode && (
        <DistributorInfoReadMode
          totalSales={totalSales}
          hpDedicatedSales={hpDedicatedSales}
          employersCount={employersCount}
        />
      )}
      {isEditMode && (
        <DistributorInfoEditMode
          totalSales={totalSales}
          hpDedicatedSales={hpDedicatedSales}
          employersCount={employersCount}
        />
      )}
    </div>
  )
}
